import { OrganizationUserBulkPublicKeyResponse } from "../organization-user-bulk-public-key.response";

export class ProviderUserBulkPublicKeyResponse extends OrganizationUserBulkPublicKeyResponse {}
